import { takeEvery, call, put, select } from 'redux-saga/effects';
import { values, uniq, without, flatten, compact } from 'lodash';
import { logger } from '@commutifi-fe/logger';
import { getCurrentId } from 'store/modules/accounts/selectors';
import * as selectors from './selectors';
import * as actions from './actions';
import { fetchPlansSubsidies as fetchPlansSubsidiesApiCall } from 'api/modules/routes/api';
import routesTypes from 'store/modules/routes/types';
import FETCH_STATUS from 'constants/global';
export const benefitsSagas = [takeEvery(routesTypes.FETCH_SUGGESTION_ROUTES_SUCCESS, getPlansSubsidiesFromRoute)];
export function* getPlansSubsidiesFromRoute({
  payload
}) {
  try {
    const accountId = yield select(getCurrentId);
    const suggestions = values(payload.entities.route);
    const planIdsBySuggestion = suggestions.map(s => {
      // Get all suggestion plan ids to get the subsidies of those plans
      const legsById = payload.entities.leg;
      const planIds = without(s.legs.map(legId => legsById[legId].planId), null);
      return planIds;
    });
    const planIds = flatten(planIdsBySuggestion);
    if (planIds.length <= 0) return;
    yield call(fetchPlansSubsidiesApiCall, {
      payload: {
        accountId,
        planIds: compact(uniq(planIds))
      }
    });
  } catch (error) {
    logger.error(error);
  }
}
export function* getPlansSubsidies(planIds) {
  try {
    const accountId = yield select(getCurrentId);
    const benefitsStatus = yield select(selectors.getFetchStatus);
    const unloadedIds = planIds.filter(id => !benefitsStatus[id] || benefitsStatus[id] !== FETCH_STATUS.LOADED);
    if (unloadedIds.length <= 0) return;
    yield call(fetchPlansSubsidiesApiCall, {
      payload: {
        accountId,
        planIds: compact(uniq(unloadedIds))
      }
    });
  } catch (error) {
    logger.error(error);
  }
}
export function* fetchPlansSubsidies({
  payload
}) {
  try {
    if (!payload.accountId || !payload.planIds || !Array.isArray(payload.planIds)) return;
    yield put(actions.fetchPlanSubsidiesRequest());
    const res = yield call(fetchPlansSubsidiesApiCall, payload.accountId, compact(uniq(payload.planIds)));
    yield put(actions.fetchPlanSubsidiesSuccess(payload.planIds, res));
  } catch (error) {
    logger.error(error);
    yield put(actions.fetchPlanSubsidiesFailure(payload.planIds, error));
  }
}